import UpdateDocument from "./UpdateDocument";
import DeleteProcoDocument from "../DeleteProcoDocument";

export default function DocumentActions({item, deletePermission, hardDeletePermission}) {
    return <>
        <UpdateDocument item={item}/>
        {deletePermission && <DeleteProcoDocument document={item} hardDeletePermission={hardDeletePermission}/>}
    </>
}